import * as React from 'react'
import { useParams } from 'react-router-dom'
import { EmploymentHistoryContainer } from 'shared/components/Onboarding/EmploymentHistory/EmploymentHistory.styles'
import { InlineSpinner } from 'shared/components/Spinner'

import { useEmploymentHistoryItem } from '../../../../hooks/query/useEmploymentHistoryItem'
import { User } from '../../../../models/user'
import { EmploymentHistoryFmcsrValidationForm } from './EmploymentHistoryFmcsrValidationForm'

type EmploymentHistoryEditFmcsrValidationProps = {
  user: User
}

export function EmploymentHistoryEditFmcsrValidation({ user }: EmploymentHistoryEditFmcsrValidationProps) {
  const { id } = useParams<{ id: string }>()
  const { employmentHistoryItem, isLoading } = useEmploymentHistoryItem({ userId: user.id, id })

  if (isLoading || !employmentHistoryItem)
    return (
      <EmploymentHistoryContainer>
        <InlineSpinner mt={10} mb={5} />
      </EmploymentHistoryContainer>
    )

  return (
    <EmploymentHistoryFmcsrValidationForm
      user={user}
      isEditing
      employmentHistoryItem={employmentHistoryItem}
    />
  )
}
